import React from 'react';
import classNames from 'classnames';

import propTypes from 'propTypes';
import LineItem from '../../containers/LineItem';
import { TranslatedMessage } from 'common/components/Intl';
import PriceSpan from 'common/components/formatters/PriceSpan';

export default class SidebarLineItems extends React.Component {
  static propTypes = {
    lineItemsSubscribable: propTypes.array.isRequired,
    lineItemsRegular: propTypes.array.isRequired,
    isMembershipOrder: propTypes.bool.isRequired,
    subscribableCostOrig: propTypes.number.isRequired,
    subscribableCostNew: propTypes.number.isRequired,
    subscribableQuantity: propTypes.number.isRequired,
  };

  renderlineItem = lineItem => {
    return <LineItem key={lineItem.id} item={lineItem} />;
  };

  render() {
    const {
      lineItemsSubscribable,
      lineItemsRegular,
      isMembershipOrder,
      subscribableCostOrig,
      subscribableCostNew,
      subscribableQuantity,
      subscribableVariantDiscountRate,
    } = this.props;

    const classNameSavings = classNames('MonthlySavingsBanner', {
      'MonthlySavingsBanner--visible':
        isMembershipOrder &&
        subscribableQuantity &&
        subscribableVariantDiscountRate > 0,
    });

    return (
      <div className="CartSidebar__line-items">
        {lineItemsSubscribable.map(l => this.renderlineItem(l))}
        <div className={classNameSavings}>
          <div
            className={classNames(
              'text--alternate',
              'MonthlySavingsBanner__title'
            )}
          >
            <TranslatedMessage id={'cart.line_items.monthly'} />
          </div>

          <PriceSpan
            className={classNames(
              'text--small',
              'MonthlySavingsBanner__price--orig'
            )}
            amount={subscribableCostOrig}
          />

          <PriceSpan
            className={classNames(
              'text--alternate',
              'MonthlySavingsBanner__price--new'
            )}
            amount={subscribableCostNew}
          />
        </div>
        {lineItemsRegular.map(l => this.renderlineItem(l))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/sidebar/LineItems.js